import { TypeParams } from "../../types";

interface EgwClientareaSleepEvaluationProps {
  // commitCurrentPlace: (placeId: number | null) => void;
  params: TypeParams; // Define the type of the ccid prop
}

const EgwClientareaSleepEvaluation: React.FC<EgwClientareaSleepEvaluationProps> = ({ params }) => {
  return <></>;
};

export default EgwClientareaSleepEvaluation;
